export default {
	home:{
		contact: 'Contact',
		contact_us: 'Contact Us',
		text: 'Great News Are Coming!<br> Let\'s Innovate Together'
	},
	contact:{
		name: 'Name',
		email: 'E-mail',
		number: 'Phone Number',
		message: 'Message',
		send: 'Send',
		back: 'Back'
	},
	notifications:{
		title_success: 'Ready!',
		error_title: 'There are problems in the form!',
		message_success: 'Thank you! We will respond soon',

		error:{
			name: 'The name is required!',
			email: 'The e-mail is required!',
			email_wrong: 'Invalid e-mail address!',
			number: 'The phone number is required!',
			message: 'The message is required!'
		}
	}
}


// WEBPACK FOOTER //
// ./src/messages/en.js